import { ApplicationsEnum, Platform } from '@quadminds/shared/commons';

export function isValidApplication(platform: string): boolean {
    const validPlatforms = [
        ApplicationsEnum.CO2,
        ApplicationsEnum.FLASH,
        ApplicationsEnum.MERCHANTS,
        ApplicationsEnum.SAAS,
        ApplicationsEnum.STORK,
    ];

    return validPlatforms.includes(platform as ApplicationsEnum);
}

export function isValidPlatform(platform: string): boolean {
    const validPlatforms = [Platform.FLASH, Platform.SAAS, Platform.STORK];

    return validPlatforms.includes(platform as Platform);
}
